var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-centering spacex-4 pointer mr-11"},[_c('InfoIcon',{staticClass:"icon-d-600 icon-16px"}),_c('span',{staticClass:"danger-600 text-sm"},[_vm._v(_vm._s(_vm.$t('An unknown error occured, please try again')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }